import { Button, ButtonProps } from '@evaneos/b2b-ui';
import { useIntl } from 'react-intl';

export const EditMessageButton = ({ sx, ...rest }: ButtonProps) => {
    const { formatMessage } = useIntl();
    return (
        <Button
            variant="outlined"
            color="primary"
            sx={{
                m: 1,
                flexShrink: 0,
                whiteSpace: 'nowrap',
                zIndex: 1,
                transition: 'opacity 0.3s',
                ...sx,
            }}
            {...rest}
        >
            {formatMessage({ id: 'discussion.edit_message.button' })}
        </Button>
    );
};
